import React, { FC } from 'react';
import { ICategoriesSide5_1 } from './params';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import Styles from './styles';
import convertToSlug from '../../../utils/convertToSlug';
import { common, routing } from '../../../translates';

const CategoriesSide: FC<{
  config: ICategoriesSide5_1;
  categories: string[];
  activeCategory?: string;
  language: string;
  activeCategoryClickable: boolean;
}> = ({ config, categories, activeCategory, language, activeCategoryClickable }) => {
  return (
    <Styles $config={config} $activeCategoryClickable={activeCategoryClickable}>
      <div className="categories-side">
        <h2 className="categories-side-header">{common[language].sectionCategoriesSide}</h2>
        <div className="categories-side-wrapper">
          <div className="categories-side-wrapper-content">
            {categories.map((category) => (
              <a
                key={category}
                href={`${routing[language].articles}/${convertToSlug(category)}/`}
                className={`categories-side-category ${activeCategory === category ? 'active' : ''}`}
              >
                {config.group_category.group_arrow.boolean_showArrow === 'true' ? (
                  <FontAwesomeIcon icon={faAngleRight} />
                ) : null}
                {category}
              </a>
            ))}
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default CategoriesSide;
